import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
    getElectricityPurchasedPerFacility,
    getRenewableEnergyPerFacility
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForFacilities from '../../../shared-components/GraphPairForFacilities';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';


export const ScopeTwoConsumptionFacilities = ({ openAccordion, changeAccordion, company, title, group, year, groupName, groupFacilities }) => {
    const dispatch = useDispatch();

    const electricityPurchasedPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.electricityPurchasedPerFacility?.data?.graph);
    const electricityPurchasedPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.electricityPurchasedPerFacility?.data?.pie);
    const renewableEnergyPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.renewableEnergyPerFacility?.data?.graph);
    const renewableEnergyPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.renewableEnergyPerFacility?.data?.pie);

    const accordionName = 'Scope Two Consumption Facility'

    useEffect(() => {
        if (openAccordion === accordionName && year && group && company) {
            dispatch(getElectricityPurchasedPerFacility(company, group, year));
            dispatch(getRenewableEnergyPerFacility(company, group, year))
        }
    }, [dispatch, openAccordion, year, group, company])

    return (
        // defaultExpanded
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <Grid container>
                <GraphMainHeader>Purchased Energy {year}</GraphMainHeader>

                <GraphSubHeader>Electricity Purchased</GraphSubHeader>
                <GraphPairForFacilities
                    barGraphData={electricityPurchasedPerFacilityGraph}
                    pieChartData={electricityPurchasedPerFacilityPie}
                    groupName={groupName}
                    facilities={groupFacilities}
                    year={year}
                    type="Electricity Purchased"
                    unit={'kWh'}
                />

                <GraphSubHeader>Renewable Energy Consumed</GraphSubHeader>
                <GraphPairForFacilities
                    barGraphData={renewableEnergyPerFacilityGraph}
                    pieChartData={renewableEnergyPerFacilityPie}
                    groupName={groupName}
                    facilities={groupFacilities}
                    year={year}
                    type='Renewable Energy Consumed'
                    unit={'kWh'}
                />
            </Grid>
        </DataAccordion>
    )
}
